import { Select, Tag } from 'antd';
import { useState } from 'react';

export type InputTagValue = {
    value: string;
    label: string;
    closable: boolean;
    idpk?: number | null;
    excluir?: 'S' | null;
    color?: string;
};

const EMPTY_TAGS: InputTagValue[] = [];

export function InputTag({
    tags = EMPTY_TAGS,
    disabled,
    onChange,
    onTagRemove,
}: {
    tags?: InputTagValue[];
    disabled?: boolean;
    onChange?: (newValue: InputTagValue[]) => void;
    onTagRemove?: (removedValue: string) => void;
}) {
    const [search, setSearch] = useState('');

    const value = tags.filter((v) => v.excluir !== 'S').map((v) => v.value);

    const handleSelect = (label: string): void => {
        const tag = tags.find((tag) => tag.label === label);

        if (tag?.idpk && tag.excluir) {
            onChange?.(
                tags.map((t) => {
                    if (t.idpk === tag.idpk) {
                        t.excluir = undefined;
                        t.value = label;
                    }

                    return t;
                }),
            );
        }

        if (!tag) {
            onChange?.([
                ...tags,
                { closable: true, excluir: undefined, idpk: undefined, label, value: label },
            ]);
        }

        setSearch('');
    };

    const handleClose = (removedValue: string): void => {
        // Procura a tag na lista
        const tag = tags.find((tag) => tag.value === removedValue);

        if (!tag) {
            return;
        }

        let newTags: InputTagValue[] = [];

        // Se tem idpk marca pra excluir
        if (tag.idpk) {
            newTags = tags.filter((t) => {
                if (t.idpk === tag.idpk) {
                    t.excluir = 'S';
                }

                return t;
            });
        } else {
            // Se não tem idpk remove a tag da lista
            newTags = tags.filter((tag) => tag.value !== removedValue);
        }

        onChange?.(newTags);
        onTagRemove?.(removedValue);
    };

    const handleClear = (): void => {
        onChange?.(tags.filter((v) => v.idpk).map((v) => ({ ...v, excluir: 'S' })));
    };

    return (
        <Select
            allowClear={false}
            className='w-full'
            disabled={disabled}
            mode='tags'
            onClear={handleClear}
            onKeyDown={(e) => {
                if (e.key === ',' || e.key === ';') {
                    e.preventDefault();
                    handleSelect(search);
                }
            }}
            onSelect={handleSelect}
            open={false}
            options={tags}
            showSearch={{
                onSearch: setSearch,
                searchValue: search,
            }}
            suffixIcon={null}
            tagRender={(props) => {
                const item = tags.find((v) => v.value === props.value);

                return (
                    <Tag
                        className='mr-1'
                        closable={item?.closable}
                        color={item?.color}
                        onClose={() => handleClose(props.value)}
                        variant='outlined'
                    >
                        <b>{props.value}</b>
                    </Tag>
                );
            }}
            value={value}
        />
    );
}
